import type { FC } from 'react';
import track from 'react-tracking';
import Modal from '@components/Modal';
import type { DeleteHoldingModalStatus } from '@/components/DeprecatedPortfolio/components/DeleteHoldingModal/redux/interface';
import type { RemoveCompanyTrigger } from '@components/AddRemoveCompany/redux/routines';

export interface DeleteHoldingModalProps {
  companyName: string;
  companyId: string;
  portfolioId: string;
  uniqueSymbol: string;
  deleteHoldingModalStatus: DeleteHoldingModalStatus;
  onClose: () => void;
  onConfirm: (data: RemoveCompanyTrigger) => void;
}

const DeleteHoldingModal: FC<DeleteHoldingModalProps> = ({
  companyName,
  companyId,
  portfolioId,
  uniqueSymbol,
  onClose,
  onConfirm,
  deleteHoldingModalStatus,
}) =>
  deleteHoldingModalStatus === 'visible' ? (
    <Modal
      title="Confirm Delete"
      onSecondaryClick={onClose}
      onPrimaryClick={() => {
        onConfirm({
          portfolioId: portfolioId,
          uniqueSymbol,
          companyId,
        });
        onClose();
      }}
      secondaryLabel="Cancel"
    >
      <p>Are you sure you want to remove {companyName} from your portfolio?</p>
    </Modal>
  ) : null;

export default track({
  type: 'track',
  subject: 'DeleteHoldingModal',
})(DeleteHoldingModal);
